import React from "react";
import { Field } from "formik";
import SimpleEntitiesSelector from "./simple-entities-selector";
import { formikPropTypes } from "components/common";

const ValidatedEntitiesSelector = ({ field: { name, value, onChange, onBlur }, ...props }) => (
  <SimpleEntitiesSelector name={name} value={value} onChange={onChange} onBlur={onBlur} {...props} />
);

ValidatedEntitiesSelector.propTypes = {
  ...formikPropTypes,
  ...SimpleEntitiesSelector.propTypes,
};

const FormEntitiesSelector = ({ name, onChange, value, onBlur, multiple, ...props }) => {
  const handleMultipleOnChange = val => onChange(name)(val);
  const handleOnChange = ({ id }) => onChange(name)(id);

  return (
    <Field
      component={ValidatedEntitiesSelector}
      field={{
        name,
        onChange: multiple ? handleMultipleOnChange : handleOnChange,
        value,
        onBlur,
      }}
      multiple={multiple}
      {...props}
    />
  );
};

FormEntitiesSelector.propTypes = {
  ...SimpleEntitiesSelector.propTypes,
};

export default FormEntitiesSelector;
